module.exports = __webpack_public_path__ + "static/media/FujiInstaxWide4.25by3.39_39.70d62589.webp";